var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 57,
    viewBox: "0 0 46 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1667_4182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 34.25C7.60512 34.25 5.25 36.6051 5.25 39.5C5.25 42.3949 7.60512 44.75 10.5 44.75C13.3949 44.75 15.75 42.3949 15.75 39.5C15.75 36.6051 13.3949 34.25 10.5 34.25ZM10.5 43C8.57008 43 7 41.4299 7 39.5C7 37.5701 8.57008 36 10.5 36C12.4299 36 14 37.5701 14 39.5C14 41.4299 12.4299 43 10.5 43ZM10.5 29C4.70099 29 0 33.701 0 39.5C0 43.7335 1.47492 44.9158 9.42091 56.4351C9.9423 57.1882 11.0576 57.1883 11.5791 56.4351C19.5251 44.9158 21 43.7335 21 39.5C21 33.701 16.299 29 10.5 29ZM10.5 54.9181C2.8823 43.9017 1.75 43.027 1.75 39.5C1.75 37.1628 2.66016 34.9655 4.31282 33.3128C5.96548 31.6602 8.16277 30.75 10.5 30.75C12.8372 30.75 15.0345 31.6602 16.6872 33.3128C18.3398 34.9655 19.25 37.1628 19.25 39.5C19.25 43.0268 18.1184 43.9007 10.5 54.9181Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1667_4182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 4.125C35.1565 4.125 33.25 5.97545 33.25 8.25C33.25 10.5245 35.1565 12.375 37.5 12.375C39.8435 12.375 41.75 10.5245 41.75 8.25C41.75 5.97545 39.8435 4.125 37.5 4.125ZM37.5 11C35.9377 11 34.6667 9.76637 34.6667 8.25C34.6667 6.73363 35.9377 5.5 37.5 5.5C39.0623 5.5 40.3333 6.73363 40.3333 8.25C40.3333 9.76637 39.0623 11 37.5 11ZM37.5 0C32.8056 0 29 3.69364 29 8.25C29 11.5763 30.194 12.5052 36.6264 21.5561C37.0485 22.1479 37.9514 22.148 38.3736 21.5561C44.806 12.5052 46 11.5763 46 8.25C46 3.69364 42.1944 0 37.5 0ZM37.5 20.3642C31.3333 11.7085 30.4167 11.0212 30.4167 8.25C30.4167 6.4136 31.1535 4.68716 32.4913 3.38864C33.8292 2.09013 35.608 1.375 37.5 1.375C39.392 1.375 41.1708 2.09013 42.5087 3.38864C43.8465 4.68716 44.5833 6.4136 44.5833 8.25C44.5833 11.0211 43.6673 11.7077 37.5 20.3642Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 56L26.7527 54.9855C35.0153 53.971 47.3925 49.5072 30.7997 39.7681C14.207 30.029 28.6076 23.1981 37.882 21",
    stroke: "black",
    strokeDasharray: "3 3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1667_4182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 28,
    fill: "white",
    transform: "translate(0 29)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1667_4182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 22,
    fill: "white",
    transform: "translate(29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.eac9b76ad4c3cef5639798c3058ece7c.svg";
export { ForwardRef as ReactComponent };